module.exports = __webpack_public_path__ + "img/p61.36a91ceb.png";